export default async function ({ store, redirect, error }) {
  if (store.getters["user/IS_BAND"]) {
    try {
      const { id } = await store.dispatch("draft/CREATE")

      return redirect(`/draft/${id}/`)
    } catch (error) {
      return redirect("/")
    }
  } else return redirect("/")
}
